// extracted by mini-css-extract-plugin
export default {"container":"MenuDetailedItem_container__AQ99I","titleContainer":"MenuDetailedItem_titleContainer__rSjS3"};